import { useEffect } from 'react';
import { photoApi } from '../api/photoApi';
import { usePhotoCommonStore } from '../store/photoCommonStore';

// PhotoOrganizerLayout(라우트 레이아웃) 밖에서 SiteDetailMain을 단독 마운트할 때
// (예: 스튜디오 홈 "현장 작업물 슬라이드오버")도 commonCodes/userTags가 채워지도록
// 원래 PhotoOrganizerLayout.tsx에 있던 로딩 effect를 뽑아냈다 — 레이아웃도 이 훅을
// 그대로 쓰므로 동작은 기존과 동일하다.
export function useEnsurePhotoCommonCodes() {
  const commonCodes  = usePhotoCommonStore(s => s.commonCodes);
  const setCommonCodes = usePhotoCommonStore(s => s.setCommonCodes);
  const setUserTags     = usePhotoCommonStore(s => s.setUserTags);

  useEffect(() => {
    // 이미 채워져 있으면(같은 세션에서 다른 경로로 먼저 로드된 경우) 다시 조회하지 않는다.
    if (commonCodes) return;
    const controller = new AbortController();
    Promise.allSettled([
      photoApi.getCommonCodes(controller.signal),
      photoApi.getUserTags(controller.signal),
    ]).then(([commonResult, userTagsResult]) => {
      if (commonResult.status === 'fulfilled') {
        const data = commonResult.value.data?.data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const codes = (data as any)?.result ?? data;
        if (codes) setCommonCodes(codes);
      }
      if (userTagsResult.status === 'fulfilled') {
        const tags = userTagsResult.value.data?.data?.tags;
        if (Array.isArray(tags)) setUserTags(tags);
      }
    });
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
